/** The page's photos and screenshots: WebP, from frontend/public/img/creators. */
export const img = (name: string) => `/img/creators/${name}`;
